/** Largest US-listed companies by market cap (approximate ranking). */
export const TOP_US_STOCKS = [
  { symbol: "AAPL", name: "Apple Inc." },
  { symbol: "MSFT", name: "Microsoft Corporation" },
  { symbol: "NVDA", name: "NVIDIA Corporation" },
  { symbol: "GOOGL", name: "Alphabet Inc." },
  { symbol: "AMZN", name: "Amazon.com Inc." },
  { symbol: "META", name: "Meta Platforms Inc." },
  { symbol: "BRK-B", name: "Berkshire Hathaway" },
  { symbol: "TSLA", name: "Tesla Inc." },
  { symbol: "AVGO", name: "Broadcom Inc." },
  { symbol: "LLY", name: "Eli Lilly and Company" },
  { symbol: "JPM", name: "JPMorgan Chase & Co." },
  { symbol: "V", name: "Visa Inc." },
  { symbol: "UNH", name: "UnitedHealth Group" },
  { symbol: "XOM", name: "Exxon Mobil Corporation" },
  { symbol: "MA", name: "Mastercard Inc." },
  { symbol: "COST", name: "Costco Wholesale Corporation" },
  { symbol: "HD", name: "The Home Depot Inc." },
  { symbol: "PG", name: "Procter & Gamble Co." },
  { symbol: "JNJ", name: "Johnson & Johnson" },
  { symbol: "WMT", name: "Walmart Inc." },
];

export function getTopUsStock(symbol) {
  const normalized = String(symbol || "").trim().toUpperCase();
  return (
    TOP_US_STOCKS.find((stock) => stock.symbol === normalized) ?? {
      symbol: normalized,
      name: normalized,
    }
  );
}
